import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators,FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { NotificationService } from './../../services/notification/notification.service';
import { TypeService } from './../../services/types/type.service';
// import { DataService } from 'src/app/services/data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as noty from 'noty';
import { GoodPracticesService } from './../../services/goodPractices/goodPractices.service';

// import { ContactSuccessComponent } from 'src/app/components/modals/contact-success/contact-success.component';
@Component({
  selector: 'app-good-practices',
  templateUrl: './good-practices.component.html',
  styleUrls: ['./good-practices.component.scss']
})
export class GoodPracticesComponent implements OnInit {

/**************************Variables from API*********************/

  public goodPractices:any = [];


/**************************Variables from API*********************/
  public filter: any = { title : ''};
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = true;
  public responsive: boolean = false;
  public config = {
    id: 'pagination',
    itemsPerPage: 6,
    currentPage: 0
  };
  public labels: any = {
    previousLabel: 'Anterior',
    nextLabel: 'Siguiente',
    screenReaderPaginationLabel: 'Paginaión',
    screenReaderPageLabel: 'Pagina',
    screenReaderCurrentLabel: `Te encuentras aqui`
  };


  
  constructor(
    private http:HttpClient,
    private formBuilder: FormBuilder,
    private _types: TypeService,
    private GoodPracticesService:GoodPracticesService,
  ){

  }

  ngOnInit() {
    this.getPublications();
  }

  getPublications(){
    this.GoodPracticesService.getPractices().subscribe(goodPractices => {
      this.goodPractices = goodPractices;
    })
  }

 
  onPageChange(number: number) 
  {
    this.config.currentPage = number;
  }

}

